import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ModalOrder from '../Containers/ModalOrder/ModalOrder';
import { controlModalOrder } from '../Actions/app';
import updateCartIcon from '../utilities/updateCartIcon';

const Header = props => {
  const { orderGoods, controlModal } = props;
  const arrBtnCart = document.querySelectorAll('.btn-cart');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arrBtnCart.length; i++) {
    arrBtnCart[i].onclick = () => {
      controlModal(true);
    };
  }

  useEffect(() => {
    updateCartIcon(orderGoods);
  }, [orderGoods]);

  return <ModalOrder />;
};

const mapStateToProps = state => ({
  orderGoods: state.currentOrder.order && state.currentOrder.order.goods
});

const mapDispatchToProps = {
  controlModal: controlModalOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
